/**
 * Evaluate EM parameter
 */
export default (fare, param) => {
  if (
    param &&
    (typeof param === 'string' || param instanceof String) &&
    param.indexOf('@@') !== -1
  ) {
    const paramEvaluation = param.split('.');

    if (paramEvaluation && paramEvaluation.length) {
      const paramsEvalLength = paramEvaluation[1].length;
      // fieldFare contain the field from api
      const fieldFare = paramEvaluation[1].substr(0, paramsEvalLength - 2);

      if (fare) {
        return fare[fieldFare];
      }
    }
  }

  return param;
};
